export default __webpack_public_path__ + "static/media/social-twitter.f8b88ebe.svg";